import { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import store from "./store/configureStore";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./themes";
import { AuthProvider } from "react-oidc-context";
import oidcConfig from "./config/oidc/config";
import {
  createBrowserRouter,
  Outlet,
  RouterProvider
} from "react-router-dom";
import { SnackbarUtilsConfigurator } from "./components/Toast";
import { SnackbarProvider } from "notistack";
import Loader from "./components/Loader";
import { PromptContext } from "src/components/NavigationAlertPrompt";
import { ErrorBoundary } from "react-error-boundary";
import { GenericErrorFallback } from "./components/ErrorFallback/ErrorFallback";
import "./config/i18n";

localStorage.setItem("item", "true");
localStorage.setItem("report", "true");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const App = lazy(() => import("./App"));

const router = createBrowserRouter([
  {
    element: (
      <PromptContext>
        <SnackbarProvider
          maxSnack={6}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          autoHideDuration={10000}
        >
          <SnackbarUtilsConfigurator />
          <Suspense fallback={<Loader height="100vh" width="100vw" />}>
            <Outlet />
          </Suspense>
        </SnackbarProvider>
      </PromptContext>
    ),
    children: [
      {
        path: "*",
        element: <App />
      }
    ]
  }
]);

root.render(
  <Suspense fallback={<Loader height="100vh" width="100vw" />}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary FallbackComponent={GenericErrorFallback}>
        <AuthProvider {...oidcConfig}>
          <Provider store={store}>
            <RouterProvider router={router} />
          </Provider>
        </AuthProvider>
      </ErrorBoundary>
    </ThemeProvider>
  </Suspense>
);
